import React, { useContext } from 'react';
import AppStateContext from '../../app/context/appStateContext';
import StyledCustomerLogo from './index.style';

const CustomerLogo: React.FC<any> = (): React.ReactElement => {
  const { customerInfoMap, selectedCustomerId } = useContext(AppStateContext);
  const logoImageUrl = customerInfoMap[selectedCustomerId]!= undefined? customerInfoMap[selectedCustomerId].logo:'';

  return (
    <StyledCustomerLogo>
      <img src={logoImageUrl} alt="Customer Logo" />
    </StyledCustomerLogo>
  );
};

export default CustomerLogo;
